/* global $ */
import lazySizes from 'lazysizes';
import Vue from 'vue';
import Cities from '../../components/City/UserCity.vue';
import FormSendSuccess from '../../components/FormSendSuccess/FormSendSuccess.vue';
import OfflineMessageView from '../../components/OfflineMessage/OfflineMessageView.vue';
import WebimWidget from '../../components/WebimWidget/WebimWidget.vue';
import { factory as renderContactCenterPhone } from '../../components/ContactCenterPhone/ContactCenterPhone.vue';

import VueFactory from '../../helpers/vueFactory';

import initEvents from '../../helpers/initEvents';
import getUTMTags from '../../helpers/UTM-tags';

getUTMTags();

document.addEventListener('lazybeforeunveil', (e) => {
  let bg = (window.innerWidth < 768)
    ? e.target.dataset.bgMobile
    : e.target.dataset.bgDesktop;
  bg = bg || e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = `url(${bg})`;
  }
  const bgLazy = (window.innerWidth < 768)
    ? e.target.dataset.bgMobileLazy
    : e.target.dataset.bgDesktopLazy;

  if (bgLazy) {
    setTimeout(() => {
      e.target.style.backgroundImage = `url(${bgLazy})`;
    }, 5000);
  }
});

export default function initApplicationGlobal(eventHub) {
  if (window.initApplicationGlobal) return;
  window.initApplicationGlobal = true;
  if (document.querySelector('.form[data-type="feedback"]')) {
    const FormFeedback = () => import(
      /* webpackChunkName: "FormFeedback" */
      '../../components/FormFeedback/FormFeedback.vue'
    );
    FormFeedback().then((module) => {
      VueFactory(module.default, {
        el: '.form[data-type="feedback"]',
      });
    });
  }

  lazySizes.init();
  /*
  * если не главная и не частным клиентам,
  * показываем меню для остальных страниц,
  * это сделано что бы избежать ситуации мелькающего хедера на странице, изначально он пустой
  * и взависимости от страницы показывается актуальный
  */
  if (!window.location.pathname.match(/^\/\/?$/i) || !window.location.pathname.match(/^\/castnym-klientam\/(.*)\/?$/i)) {
    $('#headerDesktopHiddenPart').css('opacity', '1');
  }

  VueFactory(Cities, { el: '#cities' }, {
    data() {
      return {
        eventHub,
      };
    },
  });

  const successContainer = document.createElement('div');
  const containerId = `container_${Math.floor(Math.random() * 10000)}`;
  successContainer.setAttribute('id', containerId);
  document.body.appendChild(successContainer);

  const modal = VueFactory(FormSendSuccess, { el: `#${containerId}` }, {
    data() {
      return {
        type: containerId,
      };
    },
  });
  document.addEventListener('submit-success', () => {
    modal.$children[0].setState({ success: true, message: '<p>Ваша заявка отправлена!</p><span>Мы с вами свяжемся в ближайшее время</span>' });
    modal.$children[0].showModal();
  });

  document.addEventListener('submit-success-partners', () => {
    modal.$children[0].setState({ success: true, message: '<p>Ваша заявка отправлена!</p><span>Ожидайте ответа в&nbsp;течение 3&nbsp;рабочих дней</span>' });
    modal.$children[0].showModal();
  });

  document.addEventListener('submit-success-message', (context) => {
    modal.$children[0].setState({ success: true, message: `<p>${context.detail.message}</p>` });
    modal.$children[0].showModal();
  });

  document.addEventListener('submit-error', (context) => {
    modal.$children[0].setState({ success: false, message: `<span>${context.detail.messages.join('</span><span>')}</span>` });
    modal.$children[0].showModal();
  });

  document.addEventListener('cityDeliveryNotFound', () => {
    modal.$children[0].setState({ success: false, message: '<span>Произошла непредвиденная ошибка, попробуйте повторить позже.</span>' });
    modal.$children[0].showModal();
  });

  document.addEventListener('submit-form-pvz-success', () => {
    modal.$children[0].setState({
      success: true,
      message: '<p>Ваша заявка отправлена!</p>'
        + '<span>Наш менеджер свяжется с Вами в течение 3-х рабочих дней'
        + ' <br>На указанную Вами электронную почту направлено письмо с условиями сотрудничества.</span>',
    });
    modal.$children[0].showModal();
  });

  document.addEventListener('submit-form-pvz-success-full', () => {
    modal.$children[0].setState({
      success: true,
      message: '<p>Спасибо, Ваша заявка принята</p>'
        + '<span>На указанную Вами электронную почту направлено письмо с условиями сотрудничества.'
        + ' <br><br>Наш менеджер свяжется с Вами в течение 3-х рабочих дней. Благодарим за интерес к компании Boxberry</span>',
    });
    modal.$children[0].showModal();
  });

  if (document.querySelector('.popup-messenger')) {
    VueFactory(WebimWidget, { el: '.popup-messenger' });
  }

  VueFactory(OfflineMessageView, { el: '#offlineMessage' });

  renderContactCenterPhone();

  if (document.querySelector('#mobile-store-upper') && $(window).width() < 581) {
    if (!sessionStorage.getItem('mobile-store-upper')) {
      sessionStorage.setItem('mobile-store-upper', 'open');
      $(window).one('scroll', () => {
        const MobileStoreUpper = () => ({
          component: import(
            /* webpackChunkName: "MobileStoreUpper" */
            '../../components/MobileStoreUpper/MobileStoreUpper.vue'
          ),
        });
        new Vue({
          render: (h) => h(MobileStoreUpper),
        }).$mount('#mobile-store-upper');
      });
    }
  }

  if (!localStorage.getItem('shown-cookie-info')) {
    $(window).one('scroll', () => {
      const cookieInfo = document.createElement('div');
      cookieInfo.className = 'cookie-info';
      document.body.appendChild(cookieInfo);
      const CookieInfo = () => ({
        component: import(
          /* webpackChunkName: "CookieInfo" */
          '../../components/CookieInfo/CookieInfo.vue'
        ),
      });
      new Vue({
        render: (h) => h(CookieInfo),
      }).$mount('.cookie-info');
    });
  }
  const btnConnect = document.querySelector('.js-btn-connect');
  if (btnConnect) {
    const BtnConnect = () => import(
      /* webpackChunkName: "BtnConnect" */
      '../../components/BtnConnect/BtnConnect'
    );
    BtnConnect().then((module) => {
      VueFactory(module.default, {
        el: btnConnect,
      });
    });
  }

  initEvents();
}
